import {ValueFormat} from "./ValueFormat";

export function ValueField() {
    return {
        onRender: (item, any, index) => {
                return ValueFormat(item[index.key]);
        }
    }
}